<template>
  <section class="grid-flex column">

    <div class="flex-1 flex row w100 middle">
      <div class="box">
        <div class="box-content">
          <div class="flex middle">
            <div class="flex-1">
              <b>Atenção:</b> Todos os produtos devem ser divulgados com seus respectivos links. Qualquer compra efetuado pelo link a comissão será sua.
            </div>
        </div>
        </div>
      </div>
    </div>

    <div class="margin-top-l">
        <h3>Links de Divulgação dos Produtos</h3>
    </div>

    <div class="flex-1 w100 margin-to-l">
      <ul>
        <li v-for="(prod, index) in products" :key="index">
          <div class="box margin-top-m">
            <div class="box-content">
              <div class="flex middle row">
                <div class="flex-3">
                  <div class="flex middle row">
                    <div class="flex-1 name margin-top-s">
                      <div class="flex middle">
                        <img  class="img-product" :src="prod.img">
                        <div class="flex-1">
                          <p>
                            {{ prod.name }}
                          </p>
                          <div class="flex column">
                            <div><small>Comissão: {{ account.tax_rate_commission | number }}%</small></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="flex-2 margin-top-s">
                      <div class="flex column details  ">
                        <p>Link Divulgação:</p>
                        <div>
                          <b>{{ _decode_link(prod) }}</b> <span class="copy" @click="copyInfo(_decode_link(prod))"><i class="far fa-copy"></i></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="action">
                  <div class="flex end">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div v-if="isEmpty" class="box center-text margin-top-l">
        <div class="box-content">
          <p>
            Não encontramos nenhuma venda. Assim que você tiver a
            primeira venda o valor da comissão vai aparecer na lista.
          </p>
        </div>
      </div>

      <div v-if="loading">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>

      <!-- pagination -->
      <div v-if="false" class="flex-1 flex row w100 middle">
        <div class="flex w100 end filters-groupo-holder">
          <div class="flex between middle">
              <paginate
                :containerClass="'pagination'"
                :page-count="totalPages"
                v-model="page"
                :page-range="5"
                :click-handler="clickCallback"
                :prev-text="'Anterior'"
                :next-text="'Próxima'"
              ></paginate>
            </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");


import { mapState } from "vuex";


export default {
  name: "product",
  components: { 
  },
  data() {
    return {
      loading: false,
      filters: {
        data: {},
        list: {},
      },
      products: [
        { id: 1, name: 'Vídeo Papai Noel 2024', baseurl: 'vpn4', img: 'https://papainoelvideo.com/assets/images/mbr-1-610x407.jpg'},
        { id: 2, name: 'Vídeo Papai Noel 2023', baseurl: 'vpn3', img: 'https://papainoelvideo.com/assets/images/mbr-610x407.jpg'},
        { id: 3, name: 'Ligação Papai Noel', baseurl: 'lpn', img: 'https://papainoelvideo.com/assets/images/product-call-367x434.png'},
        // { id: 4, name: 'Carta Papai Noel', baseurl: 'cpn', img: 'https://oferta.bopoty.com/camiseta-personalizada-pet/assets/images/wepik-export-20230929213608t4hm-421x545.webp'},
        // { id: 5, name: 'Imagens para Colorir', baseurl: 'ipc', img: 'https://oferta.bopoty.com/caneca-personalizada-pet/assets/images/221-1080x1080.webp'},
      ],
      totalProducts: 1,
      offset: 10,
      page: 1,
    };
  },
  mounted() {
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    isEmpty() {
      return this.totalProducts === 0 && !this.loading;
    },
    totalPages() {
      let valueMode = this.totalProducts % this.offset;
      let value = this.totalProducts / this.offset;

      let pages = 1;

      if (valueMode == 0) {
        pages = value;
      } else {
        pages = parseInt(value) + 1;
      }

      return pages;
    },
  },
  watch: {
    "page": {
      handler() {
        this.products = [];
      }
    }
  },
  methods: {
    async copyInfo(mytext) {
      try {
        await navigator.clipboard.writeText(mytext);
        this.$toast.success({
          title:'Sucesso',
          message:'Informação Copiada'
        })
      } catch($e) {
        this.$toast.error({
          title:'Erro',
          message:'Falha ao copiar'
        })
      }
    },
    _decode_link(prod) {
      if (prod.baseurl) {
        return `https://p.parceirospapainoel.com/${prod.baseurl}/${this.account.external_cupom_code}`
      }
      return `https://p.parceirospapainoel.com/${this.account.external_cupom_code}`

    }

  },
};
</script>

<style lang="scss" scoped>
li {
  list-style-type: none;
}

.details {
  > div {
    margin-right: 34px;
    p {
      line-height: 20px;
    }
    small {
      font-weight: 800;
    }
  }
}

.name {
  small {
    font-weight: 800;
  }
}

.profit {
  .green {
    color: green;
  }
  .red {
    color: red;
  }
}

@media screen and (max-width: 1024px) {

  .details {
    flex-direction: column;

    > div {
      margin-right: 8px;
      margin-top: 8px;
      display: flex;
      align-items: center;

      p::after {
        content: ':'
      }
      small {
        margin-left: 8px;
      }
    }

  }
  .action {
    margin-top: 16px;
  }

}

.max-status {
  max-width: 50px;
}

.approved {
  color: green;
}

.failed {
  color: red;
}

.no-value {
  display: none;
}

.commission {
  position: relative;
  &.failed { 
    .no-value {
      display: inline;
      position: absolute;
      width: 100px;
      border-bottom: 2px solid red;
      top: 7px;
      left: -14px;
      // transform: rotate(-15deg); /* Equal to rotateZ(45deg) */
    }
  }
}

.copy {
  margin-left: 16px;
  color: var(--primary);
  cursor: pointer;
}

.img-product {
  max-width: 80px;
  min-width: 80px;
  max-height: 80px;
  min-height: 80px;
  border-radius: 50%;
  margin-right: 18px;
  border: 3px solid var(--primary)
}


</style>
